exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".item-history-spinner-section {\n  margin-top: 20px;\n  font-size: 70px;\n  text-align: center; }\n\n.print-logistic-item-header-section {\n  display: flex;\n  justify-content: center;\n  align-items: center; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/item/print/item_history.scss
// module id = 1041
// module chunks = 1